<template>
	<span
		class="ao-icon"
		:style="[
			sizeStyle,
			iconColor ? `color:rgb(var(--v-theme-${iconColor})) !important` : '',
		]"
		:class="[sizeClass, `background-${color}`]"
		v-html="icon"
	/>
</template>

<script setup>
import { computed } from 'vue'
import aoIcons from '../config/ao-icons.js'

const props = defineProps({

	iconName: {
			type: String,
			default: 'box',
		},

		size: {
			type: [String, Number],
			default: 'box',
			validator: (v) => {
				if (typeof v === 'number' && v > 0) return true
				return ['box', 'small', 'default', 'large', 'x-large', '3x-large'].includes(v)
			},
		},

		iconColor: {
			type: String,
			default: null,
		},

		color: {
			type: String,
			default: null,
		},

})

const icon = computed(() => {
	let icon = aoIcons[props.iconName]
	if (!icon && import.meta.env.DEV) {
		// eslint-disable-next-line no-console
		console.log(`%c can't found icon ${props.iconName} %c`, 'font-size: 1.5em; color: red;', '')
		return ''
	}
	return typeof icon === 'object' ? icon.svg : icon
})

const sizeClass = computed(() => {
	let prefix = 'size-'
	if (typeof props.size === 'string') {
		return prefix + props.size
	}
	return ''
})

const sizeStyle = computed(() => {
	if (typeof props.size === 'number') {
		return `font-size: ${props.size}px`
	}
	return ''
})
</script>

<style lang="scss">
.ao-icon {
	//display: inline-block;
	display: inline-flex;
	height: 1em;
	font-size: 1em;
	line-height: 1;
	vertical-align: middle;
	&.size-small {
		height: 0.625em;
		font-size: 0.625em;
	}
	&.size-default {
		height: 0.8em;
		font-size: 0.8em;
	}
	&.size-large {
		font-size: 1.5em;
	}

	&.size-x-large {
		font-size: 2em;
	}
	&.size-3x-large {
		font-size: 4.7em;
	}
	svg {
		width: 1em;
		height: 1em;
	}
	&.background-background {
		background-color: rgb(var(--v-theme-background));
		width: 24px;
		height: 24px;
		display: flex;
		justify-content: center;
		align-items: center;
		border-radius: 3px;
		font-size: 0.8em;
	}
	&.background-red {
		background-color: rgb(var(--v-theme-accent));
		width: 24px;
		height: 24px;
		display: flex;
		justify-content: center;
		align-items: center;
		border-radius: 3px;
		font-size: 0.8em;
	}
	&.background-green {
		background-color: rgb(var(--v-theme-green));
		width: 24px;
		height: 24px;
		display: flex;
		justify-content: center;
		align-items: center;
		border-radius: 3px;
		font-size: 0.8em;
	}
}
</style>
